export default {
  title: "Invitation",
  description: "Vous avez été invité à collaborer sur un événement",
  
  // Statuts des invitations
  status: {
    pending: "En attente",
    accepted: "Acceptée",
    declined: "Refusée",
    expired: "Expirée"
  },
  
  // Types de ressources
  resourceTypes: {
    budget: "Budget",
    guests: "Invités",
    tasks: "Tâches",
    timeline: "Chronologie",
    vendors: "Prestataires",
    events: "Événements"
  },
  
  // Niveaux d'accès
  accessLevels: {
    view: "Lecture seule",
    edit: "Modification",
    manage: "Gestion complète"
  },
  
  // Actions
  actions: {
    accept: "Accepter",
    decline: "Refuser"
  },
  
  // Labels
  accessLevel: "Niveau d'accès",
  expiresAt: "Expire le",
  invitedBy: "Invité par",
  unknownUser: "Utilisateur inconnu",
  
  // Messages de succès
  success: {
    accepted: "Invitation acceptée avec succès",
    declined: "Invitation refusée"
  },
  
  // Messages d'erreur
  errors: {
    invalidToken: "Token d'invitation invalide",
    notFound: "Invitation introuvable",
    expired: "Cette invitation a expiré",
    accept: "Erreur lors de l'acceptation de l'invitation",
    decline: "Erreur lors du refus de l'invitation",
    loadInvitation: "Erreur lors du chargement de l'invitation",
    pendingInvitation: "Erreur lors de la vérification des invitations en attente"
  },

  // Page d'accueil invité (Landing Page)
  landing: {
    welcome: "Bienvenue, {{name}} !",
    welcomeGeneric: "Accès Partagé",
    subtitle: "Entrez votre adresse email pour accéder aux ressources partagées",
    subtitleAuthenticated: "Vous avez été invité à collaborer sur cet événement.",
    confirmIdentity: "Confirmez votre identité pour accéder à l'espace sécurisé réservé à",
    emailLabel: "Adresse email",
    emailPlaceholder: "votre@email.com",
    emailHelp: "Utilisez l'adresse email avec laquelle vous avez reçu l'invitation",
    submitButton: "Accéder à l'espace",
    validating: "Validation...",
    securityTitle: "Info sécurité",
    securityPoint1: "Ce lien est unique et sécurisé",
    securityPoint2: "L'accès est strictement réservé à l'email invité",
    securityPoint3: "Aucune création de compte n'est requise",
    errorToken: "Token de partage manquant dans l'URL",
    errorValidation: "Lien invalide ou email incorrect. Vérifiez que vous utilisez la bonne adresse email.",
    errorGeneric: "Une erreur est survenue lors de la validation"
  }
};
